import React, { useEffect, useRef, useState } from 'react';
import './Screenshots.css';

const SCREENSHOTS = [
  { src: '/screenshots/login-1.PNG', title: 'Écran de connexion' },
  { src: '/screenshots/home-1.PNG', title: 'Accueil et solde' },
  { src: '/screenshots/home-2.PNG', title: 'Actions rapides' },
  { src: '/screenshots/topup-1.PNG', title: 'Recharge Orange Money' },
  { src: '/screenshots/topup-2.PNG', title: 'Recharge Sama Money' },
  { src: '/screenshots/cards-1.PNG', title: 'Liste des cartes' },
  { src: '/screenshots/cards-2.PNG', title: 'Détails de carte' },
  { src: '/screenshots/cards-3.PNG', title: 'Transactions de carte' },
  { src: '/screenshots/transaction-1.PNG', title: 'Historique des transactions' },
  { src: '/screenshots/reset-1.PNG', title: 'Réinitialisation du mot de passe' },
  { src: '/screenshots/reset-2.PNG', title: 'Nouveau mot de passe' },
];

const Screenshots = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const closeRef = useRef(null);

  useEffect(() => {
    if (!selectedImage) {
      return undefined;
    }
    closeRef.current?.focus();
    const onKey = (event) => {
      if (event.key === 'Escape') {
        setSelectedImage(null);
      }
    };
    window.addEventListener('keydown', onKey);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = previousOverflow;
    };
  }, [selectedImage]);

  return (
    <section id="screenshots" className="screenshots">
      <div className="container">
        <h2 className="section-title">L’app en images</h2>
        <p className="section-subtitle">
          Connexion, recharge, cartes et historique — le parcours Shini Pay.
        </p>
        <ul className="screenshots-grid">
          {SCREENSHOTS.map((screenshot) => (
            <li key={screenshot.src}>
              <button
                type="button"
                className="screenshot-item"
                onClick={() => setSelectedImage(screenshot)}
              >
                <img
                  src={screenshot.src}
                  alt=""
                  className="screenshot-thumbnail"
                />
                <span className="screenshot-title">{screenshot.title}</span>
              </button>
            </li>
          ))}
        </ul>
      </div>
      {selectedImage && (
        <div
          className="modal"
          role="dialog"
          aria-modal="true"
          aria-labelledby="screenshot-dialog-title"
          onClick={() => setSelectedImage(null)}
        >
          <div className="modal-content" onClick={(event) => event.stopPropagation()}>
            <button
              ref={closeRef}
              type="button"
              className="modal-close"
              onClick={() => setSelectedImage(null)}
            >
              Fermer
            </button>
            <img
              src={selectedImage.src}
              alt={selectedImage.title}
              className="modal-image"
            />
            <p id="screenshot-dialog-title" className="modal-title">{selectedImage.title}</p>
          </div>
        </div>
      )}
    </section>
  );
};

export default Screenshots;
